<template>
	<div class="notifications">

		<div class="head">
			<md-button class="md-raised" v-on:click.native="createNotification()">Új értesítés létrehozása</md-button>
		</div>

		<div v-if="notifications.length <= 0" style="text-align: center; color: white; font-size: 20px;">
			..Betöltés..
		</div>

		<div v-for="notification in notifications" class="card">
			
			<md-input-container>
				<label>Értesítés címe</label>
				<md-input v-model="notification.title"></md-input>
			</md-input-container>
			<md-input-container>
				<label>Értesítés szövege</label>
				<md-textarea v-model="notification.body"></md-textarea>
			</md-input-container>
			<section class="card options" v-if="notification.options">
				<span class="subtitle">Válaszlehetőségek</span>
				<div v-for="option in notification.options">
					<md-input-container>
						<label>Válasz</label>
						<md-input v-model="option.title"></md-input>
					</md-input-container>
				</div>
			</section>
			
			<!--
			<span v-if="!notification.saved" class="save-prompt">
				Még nincs elmentve
			</span>
		-->
		<div class="block actions row">
			<div class="col-md-12 end-md">
				Érvényes: <date-picker class="date-picker" :date="notification.targetDate" :option="option" :limit="limit"></date-picker>
				<md-checkbox v-model="notification.published">Publikálva</md-checkbox>
			</div>
			<div class="col-md-2 start-md">
				<md-button class="md-warn" v-on:click.native="deleteNotification(notification)">Törlés</md-button>
			</div>
			<div class="col-md-10 end-md">
				<md-button class="md-accent" v-on:click.native="pushNotification(notification)">Push értesítés küldése</md-button>
				<md-button class="md-accent" v-on:click.native="addOption(notification)">Válaszlehetőség hozzáadása</md-button>
				<md-button class="md-primary" v-on:click.native="saveNotification(notification)">Mentés</md-button>
			</div>
		</div>
	</div>
</div>
</template>

<script>
	import FirebaseDBService from '../../services/FirebaseDBService'
	import FCMService from '../../services/FCMService'
	import Api from '../../../generated'
	import Vue from 'vue'
	import datePicker from 'vue-datepicker'
	import moment from 'moment'

	export default {
		components: {
			'date-picker': datePicker
		},
		data () {
			return {
				notifications: [],
				option: {
					type: 'min',
					week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
					month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
					format: 'YYYY-MM-DD HH:mm',
					placeholder: 'Mikor?'
				},
				limit: []
			}
		},
		methods: {
			createNotification: function(){
				var notification = new Api.Question;
				notification.published = false;
				notification.type = "notification";
				notification.saved = false;
				notification.targetDate = {
					time: moment().format('YYYY-MM-DD HH:mm')
				};
				this.notifications.unshift(notification);
			},
			saveNotification: function(notification){
				if(!notification.createdAt){
					notification.createdAt = new Date().toISOString();
				}
				notification.updatedAt = new Date().toISOString();
				notification.targetDate = moment(notification.targetDate.time).utcOffset(moment().utcOffset()).toDate().toISOString();
				FirebaseDBService.saveNotification(notification);
				this.$set(notification, 'saved', true);
				this.reload();
			},
			pushNotification: function(notification){
				FCMService.sendGlobalNotification(notification, (err) => {
					console.log(err);
				});
			},
			addOption: function(notification){
				if(!notification.options){
					this.$set(notification, 'options', []);
				}
				notification.options.push({});
			},
			deleteNotification: function(notification){
				FirebaseDBService.deleteNotification(notification);
				this.notifications.splice(this.notifications.indexOf(notification), 1);
			},
			reload: function(){
				FirebaseDBService.getNotifications((err, notifications) => {
					for(let notification of notifications){
						notification.targetDate = {time: moment(notification.targetDate).format('YYYY-MM-DD HH:mm')};
						console.log(notification.targetDate );
					}
					this.notifications = notifications.reverse();
				});
			}
		},
		created () {
			this.reload();
		}
	}
</script>

<style scoped>
	.tip{
		font-size: 15pt;	
	}
	.tip span{
		font-size: 13pt;
	}
	.save-prompt{
		color: #e74c3c;
		font-size: 13pt;
	}
	.actions{
		text-align: left;
		padding: 0;
	}
	.subtitle{
		font-size: 13pt;
	}
</style>


// WEBPACK FOOTER //
// Notifications.vue?11aa6d96